import { actions as loadingActions } from "../../components/loading/index";
import { notification, message } from "antd";

export const removeHOD = email => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());

    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    firestore
      .doc(`faculty/${email}`)
      .delete()
      .then(function() {
        message.success("HOD removed successfully");
        firestore
          .collection("faculty")
          .get()
          .then(doc => {
            dispatch({
              type: "LOAD_FACULTY_LIST",
              payload: !doc.empty
                ? {
                    valid: true,
                    data: doc.docs.map(doc => doc.data())
                  }
                : { valid: false }
            });
            dispatch(loadingActions.hideLoading());
          })
          .catch(function(error) {
            
            dispatch(loadingActions.hideLoading());
          });
      })
      .catch(function(error) {
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const addTeam = formVal => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());
    const firestore = getFirestore();
    const state = getState();
    const batch = firestore.batch();
    const displayName = getState().firebase.auth.displayName;
    const uid = getState().firebase.auth.uid;

    const finalMembers = state.auth.studentList.data.filter(el =>
      formVal.members.includes(el.UID)
    );

    firestore
      .collection("teams")
      .add({
        teamName: formVal.teamName,
        createdOn: new Date().toLocaleDateString(),
        teamSize:finalMembers.length,
        teamDiscription:formVal.teamDiscription,
        createdBy:{
          displayName:displayName,
          UID:uid
        }
      })
      .then(team => {
        finalMembers.forEach(member => {
          batch.set(
            team.collection("members").doc(member.UID),
            {
              name: member.displayName,
              branch: member.branch,
              section: member.section,
              campus: member.campus ? member.campus : "",
              gradYear: member.gradYear ? member.gradYear : "",
            },
            { merge: true }
          );
        });
        batch.commit().then(() => {
          message.success("Team added successfully");
          dispatch(loadingActions.hideLoading());
        });
      })
      .catch(function(error) {
        // 
        dispatch(loadingActions.hideLoading());
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const loadStudentList = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    dispatch(loadingActions.showLoading());
    firestore
      .collection("students")
      .where("role", "==", "STUDENT")
      .get()
      .then(doc => {
        
        if(!doc.empty){
        dispatch({
          type: "LOAD_ALL_STUDENTS",
          payload: !doc.empty
            ? {
                valid: true,
                data: doc.docs.map((doc, i) => {
                  return { key: `${i}`, ...doc.data(), projectsDoneListArray:doc.data().projectsDoneListArray || [],workshopsAttendedArray:doc.data().workshopsAttendedArray||[],InternshipAttendedArray:doc.data().InternshipAttendedArray || [],certificationArray:doc.data().certificationArray||[],pubicationsArray:doc.data().pubicationsArray||[],conferenceAttendedArray:doc.data().conferenceAttendedArray||[],technicalSkillsArray:doc.data().technicalSkillsArray||[]};
                }),
              }
            : { valid: false }
        });
        dispatch(loadingActions.hideLoading());
      }
      else{
        dispatch({
          type: "LOAD_ALL_STUDENTS",
          payload: doc.empty
            ? {
                valid: true,
                data: []
              }
            : { valid: false }
        });
        dispatch(loadingActions.hideLoading());
        message.error(
          "No Students Found"
        );
      }
      })
      .catch(function(error) {
        
        dispatch(loadingActions.hideLoading());
      });
  };
};
